import { Button, Container } from 'react-bootstrap'
import React, { useMemo, useEffect, useState, useRef } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { QRCode } from 'react-qr-code';
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import Modal from 'react-bootstrap/Modal'
import moment from 'moment'
import Palette from "../../Palette";
import mitraMemberCard from "../../assets/member_card_v3_mitra.png"
import penuhMemberCard from "../../assets/member_card_v3_penuh.png"

export default function MemberCardModalV3(props) {

  const { show, close, data } = props

  console.log("datax", data)

  const [refWidth, setRefWidth] = useState(0)
  const [trigger, setTrigger] = useState("red")
  const [baseTextColor, setBaseTextColor] = useState("white")
  const [loadQrCode, setLoadQrCode] = useState(false)

  const cardRef = useRef(null)

  const processLanguagePair = () => {
    let languagesToReturnPair = [];
    if (data?.languages) {
      data.languages.forEach(l => {
        let found = false;
        languagesToReturnPair.forEach((ltr, ltrIndex) => {
          if ((ltr.from === l.language_from_code && ltr.to === l.language_to_code) ||
            (ltr.from === l.language_to_code && ltr.to === l.language_from_code)) {
            found = true;
            languagesToReturnPair[ltrIndex].two_way = true;
          }
        });

        if (!found) {
          languagesToReturnPair.push({
            from: l.language_from_code,
            to: l.language_to_code,
            two_way: false
          });
        }
      });
      languagesToReturnPair = languagesToReturnPair.map(pair => ({
        ...pair,
        text: pair.two_way ?
          `${pair.from}-${pair.to} | ${pair.to}-${pair.from}` :
          `${pair.from}-${pair.to}`
      }));
    }

    return languagesToReturnPair;
  }


  let cardColor, fontcolor
  if (data.role == "MUDA") {
    cardColor = penuhMemberCard
    fontcolor = "#FFFFFF"

  } else if (data.role === "MITRA") {
    cardColor = mitraMemberCard
    fontcolor = "#0000FF"
  } else {
    cardColor = penuhMemberCard
    fontcolor = "#FFFFFF"
  }

  function roleMappingLabel(str) {
    let objRole = {
      name: '',
      name_en: ''
    }

    if (str === 'PENUH') {
      objRole.name = "Anggota Profesional"
      objRole.name_en = "Professional Member"
    } else if (str === 'MITRA') {
      objRole.name = "Anggota Mitra"
      objRole.name_en = "Associate Member"
    } else if (str === 'MUDA') {
      objRole.name = "Anggota Muda"
      objRole.name_en = "Junior Member"
    } else {
      objRole.name = "-"
      objRole.name_en = "-"
    }

    return objRole
  }

  function validateMemberCard(memberCard, nonMemberCard) {
    if (memberCard === undefined) {
      return moment(nonMemberCard).format("YYYY")
    } else {
      return moment(memberCard).format("YYYY")
    }
  }


  const getMemberResultUrl = () => {
    const baseUrl = window.location.origin;
    return `${baseUrl}/result/${data.id}`;
  }

  console.log("GMRU", getMemberResultUrl())

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setLoadQrCode(true)
      }, 1000)
    }
  }, [show])
  useEffect(() => {
    if (cardRef) {
      console.log("cardref UE", cardRef)
      // setWidth()
    }
  }, [cardRef])

  useEffect(() => {
    if (props.show) {
      setTimeout(() => {
        console.log("triggering")
        setTrigger(trigger === "red" ? "yellow" : "red")
      }, 500)
    }
  }, [props.show])

  const handleClose = () => {
    close()
  }

  const downloadCard = async () => {

    const element = document.getElementById('print-card')
    const canvas = await html2canvas(element, { useCORS: true, scale: 4 })
    const cardData = canvas.toDataURL('image/jpg')
    let pdf = new jsPDF('l', 'mm', [330, 560], true)//70,40
    pdf.addImage(cardData, 'PNG', 0, 0.5, 200, 114, '','FAST');
    pdf.save(`MemberCard-${data?.full_name}.pdf`);
  }

  let cardHeight = refWidth ? refWidth * 600 / 1051 : 1
  let cardWidth = refWidth ? refWidth * 320 / 1051 : 1
  return <>
    <Modal
      show={show}
      onHide={handleClose}
      size={'lg'}
    >
      <Modal.Header closeButton>
        Kartu Anggota {data?.full_name}
      </Modal.Header>
      <Modal.Body>
        <div
          id="print-card"
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            color: trigger,
            background: cardRef ? null : trigger,
          }}
          ref={cardRef}
        >
          <div
            className={"d-flex flex-column"}
            ref={(ref) => {
              console.log("cardref2", ref?.clientWidth)
              if (ref && refWidth === 0) {
                console.log("cardref", ref?.clientWidth)
                setRefWidth(ref.clientWidth)
              }
            }}
            style={{
              background: `url(${cardColor})`,
              height: cardHeight,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              width: "100%"

            }}>
            <Container style={{ paddingLeft: refWidth * 0.07 }}>
              <Row style={{ marginTop: cardHeight * 0.4 }}>
                <Col
                  className={"d-flex flex-column"}
                  md={6} style={{ color: fontcolor }}>
                  <div style={{ fontWeight: 'bold', fontSize: cardHeight * 0.070, lineHeight: 1.05, color: fontcolor, textTransform: 'capitalize' }} className='pt-serif-bold'>{data?.full_name}</div>
                  {
                    data?.profession === "Both" ?
                      <>
                        <div style={{ fontSize: cardHeight * 0.035, lineHeight: 1.1, color: fontcolor }} className={"pt-sans-regular"}>Penerjemah/<i className={"proxima-novai"}>Translator</i></div>
                        <div style={{ fontSize: cardHeight * 0.035, lineHeight: 1.1, color: fontcolor }} className={"pt-sans-regular"}>Juru Bahasa/<i className={"proxima-nova-i"}>Interpreter</i></div>
                      </>
                      :
                      data?.profession === "Translator" ?
                        <div style={{ fontSize: cardHeight * 0.04, color: fontcolor }} className={"pt-sans-regular"}>Penerjemah/<i className={"proxima-nova-i"}>Translator</i></div>
                        :
                        <div style={{ fontSize: cardHeight * 0.04, color: fontcolor }} className={"pt-sans-regular"}>Juru Bahasa/<i className={"proxima-nova-i"}>Interpreter</i></div>
                  }
                </Col>
                <Col
                  className={"d-flex flex-column"}
                  md={6}
                >
                  {/* <div style={{ fontWeight: 700, color: 'white', fontSize: cardHeight * 0.03 }} className={"proxima-nova"}>No. Anggota/<i className={"proxima-nova-i"}>Membership ID</i></div> */}
                  <div style={{ fontWeight: 'bold', fontSize: cardHeight * 0.06, lineHeight: 1, color: fontcolor }} className={"pt-sans-bold"}>
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      maxWidth: cardWidth,
                      left: cardWidth * 0.28,
                      height: '100%',
                      maxHeight: cardHeight,
                      zIndex: 1,
                      margin: '0 auto',
                    }}>
                      {
                        loadQrCode ? <>
                          <div style={{ margin: '0 auto', textAlign: 'center', padding: 10, width: 'max-content', background: '#ffffff', border: data?.role === 'MITRA' ? '5px solid #0000FF' : 'none' }}>

                            <QRCode
                              value={getMemberResultUrl()}
                              level="H"
                              style={{
                                width: '100%',
                                height: 110,

                              }}
                            />
                          </div>
                        </> : ''
                      }



                    </div>


                  </div>
                  <div style={{ position: 'relative', top: cardHeight * 0.34, gap: 5, display: 'flex', flexDirection: 'column' }}>
                    <div style={{ fontWeight: 'bold', fontSize: cardHeight * 0.06, lineHeight: 1, color: fontcolor }} className={"pt-serif-bold text-center"}>
                      {data?.hpi_id}
                    </div>
                    <div className='mt-1'>
                      <div style={{ fontWeight: 'bold', color: fontcolor, fontSize: cardHeight * 0.03 }} className={"pt-sans-regular text-center"}>
                        {roleMappingLabel(data?.role).name}</div>
                      <div style={{ fontWeight: 'bold', color: fontcolor, fontSize: cardHeight * 0.03 }} className={"pt-sans-regular text-center"}>
                        <i className={"proxima-nova-i"}>
                          {roleMappingLabel(data?.role).name_en}
                        </i></div>
                    </div>

                  </div>


                </Col>
              </Row>
              <Row>
                <Col
                  className={"d-flex flex-column"}
                  md={6}>
                  {/* <div style={{ fontWeight: 700, color: 'white', fontSize: cardHeight * 0.03 }} className={"proxima-nova"}>
                    Tingkat Keanggotaan/<i>Membership Level</i>
                  </div> */}
                  <div style={{ fontWeight: 'bold', fontSize: cardHeight * 0.06, lineHeight: 1, color: fontcolor, marginTop: cardHeight * 0.05 }} className={"pt-serif-bold"}>
                    {/* Anggota {capitalizeStr(data?.member_card?.membership_role)} */}
                    {processLanguagePair().map((langPair, index) => (
                      <div
                        style={{ fontSize: cardHeight * 0.05 }}
                        key={`${langPair.from}-${langPair.to}-${index}`}
                      >
                        {langPair.text}
                      </div>
                    ))}

                  </div>
                  <div style={{ fontWeight: 'normal', color: fontcolor, fontSize: cardHeight * 0.03, marginTop: cardHeight * 0.07 }} className={"pt-sans-regular"}>
                    Masa Berlaku/<i>Card Validity</i>
                  </div>
                  <div style={{ fontWeight: 'bold', fontSize: cardHeight * 0.06, lineHeight: 1, color: fontcolor }} className={"pt-serif-bold"}>
                    {moment(data?.latest_membership?.valid_until).endOf('year').format("DD-MM-YYYY")}
                  </div>
                </Col>
                {/* <Col md={6}>
                  <div style={{ fontWeight: 700, color: 'white', fontSize: cardHeight * 0.03, marginLeft: cardHeight * 0.135 }} className={"proxima-nova"}>
                    Pasangan Bahasa/<i>Language Pair(s)</i>
                  </div>
                  <div style={{ fontWeight: 500, fontSize: cardHeight * 0.05, lineHeight: 1.05, color: fontcolor, marginLeft: cardHeight * 0.1350 }} className={"fira-sans"}>
                    {processLanguagePair().map((obj, key) => {
                      return <div key={key}>{obj.from}{obj.two_way ? " <> " : " > "}{obj.to}</div>
                    })}
                    {data?.hpi_id}
                  </div>
                  {refWidth > 0 && (
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: cardHeight * 0.05
                    }}>
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '70px'
                      }}>
                        <div style={{
                          fontWeight: 500,
                          color: 'white',
                          fontSize: cardHeight * 0.035,
                          marginBottom: '6px',
                          textAlign: 'center'
                        }}>
                          QR Code
                        </div>
                        <QRCode
                          value={getMemberResultUrl()}
                          size={60}
                          level="H"
                          style={{
                            height: "auto",
                            width: "100%"
                          }}
                        />
                      </div>
                    </div>
                  )}


                </Col> */}
              </Row>
            </Container>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={downloadCard}>
          Unduh kartu elektronik
        </Button>
      </Modal.Footer>
    </Modal>
  </>
}